import { CobaltClickableTile } from '@cae/cobalt-react/components/tile';
import { CobaltIconCircleSolid } from '@cae/cobalt-react/icons/solid/CobaltIconCircleSolid';
import { formatAmount } from '@features/invoices/utils/invoices.utils';
import { formatDateShort } from '@shared/utils/format-date/formatDate';
import * as React from 'react';

import type { PastDueInvoiceItemProps } from './PastDueInvoiceItem.types';

import styles from './PastDueInvoiceItem.module.css';

const PastDueInvoiceItem = React.memo(
  ({
    invoice,
    onInvoiceClick,
  }: Readonly<PastDueInvoiceItemProps>): React.ReactElement => {
    const handleClick = React.useCallback((): void => {
      onInvoiceClick(invoice.accountReceivableId);
    }, [onInvoiceClick, invoice.accountReceivableId]);

    return (
      <CobaltClickableTile
        data-testid="past-due-invoice-item"
        onClick={handleClick}
      >
        <div className={styles.invoiceItemContent}>
          <div className={styles.invoiceItemMain}>
            <div className={`body-01 ${styles.transactionNumber}`}>
              {invoice.transactionNumber}
            </div>
            <div className={`body-02 ${styles.amount}`}>
              {formatAmount(invoice.totalAmount, invoice.currency)}
            </div>
            <div className={`body-01 ${styles.dueDate}`}>
              Past due since {formatDateShort(invoice.dueDate)}
            </div>
          </div>

          <div className={styles.statusIndicator}>
            <CobaltIconCircleSolid aria-hidden="true" />
          </div>
        </div>
      </CobaltClickableTile>
    );
  }
);

PastDueInvoiceItem.displayName = 'PastDueInvoiceItem';
export { PastDueInvoiceItem };
